import React from 'react';
import { Helmet } from 'react-helmet-async';
import Hero from '../components/Hero';
import TopTrees from '../components/TopTrees';
import Gallery from '../components/Gallery';
import Footer from '../components/Footer';
import PrizesShowcase from '../components/PrizesShowcase';

const Home = () => {
  return (
    <>
      <Helmet>
        <title>Concurso de Árboles de Navidad 2024 - ¡Participa y Gana!</title>
        <meta name="description" content="Participa en el mejor concurso de árboles de Navidad. Sube la foto de tu árbol, consigue votos y gana increíbles premios como una PlayStation 5." />
        <link rel="canonical" href="https://arbolnavidad.com" />
      </Helmet>
      <div className="min-h-screen">
        <Hero />
        <TopTrees />
        <PrizesShowcase />
        <Gallery />
        <Footer />
      </div>
    </>
  );
};

export default Home;